var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#A5DA05",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3l18 18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58 5.57A5 5 0 0 1 17.5 9.5h.5a3.5 3.5 0 0 1 2.4 6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H7a4 4 0 0 1-.6-7.96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudOff);
export default __webpack_public_path__ + "static/media/cloud_off.2d935f8ee05532d8e79473464ecc0142.svg";
export { ForwardRef as ReactComponent };